import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../redux/store';
import { useNavigate, useParams } from 'react-router-dom';
import qs from 'qs';
import { Placeholder } from '../components/Placeholder';

import { fetchMyHistory } from '../redux/lounges/slice';
import { selectLounges } from '../redux/lounges/selectors';
import { usersSelector } from '../redux/users/selectors';

import { LoungeHeader } from '../components/LoungeHeader';
import { MobileLoungeHeader } from '../components/MobileLoungeHeader';
import { StoreTabs } from '../components/StoreTabs';


const MyHistory = () => {
  const dispatch = useAppDispatch();
  const { myHistoryItem, status } = useSelector(selectLounges);

  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const { isLoggedIn } = useSelector(usersSelector);

  let sortType: any = null;
  let categoryId: any = null;
  let searchValue: any = null;

  const [currentPage, setCurrentPage] = useState(1);
  const [myData, SetMyData] = useState<any | string>([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchMyHistory({ sortType, currentPage })).then((res: any) => {
      SetMyData((prev: any) => [...prev, ...res.payload]);
    });
  }, [currentPage]);

  const handelInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        setCurrentPage((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handelInfiniteScroll);
    return () => window.removeEventListener('scroll', handelInfiniteScroll);
  }, []);

  function converDate(datevalue: any) {
    const date = new Date(datevalue);
    const formattedDate = date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });
    return formattedDate;
  }

  //console.log(myHistoryItem)
  return (
    <>
      <div className='mid-main'>
        <div className='container'>
          <div className='mid-sec mwstore-page-bg'>
            <LoungeHeader />
            <MobileLoungeHeader />
            <div className='mwstore-mid-bg'>
              <StoreTabs />
                  <div className='MW-buy-sec'>
                    <div className='container'>
                      <div className='row'>
                        <div className='buy-m'>
                          <div className='mws-mid-sec mb-4'>
                            <h5 className='mid-head'>My History</h5>
                          </div>

                          {status === 'loading'
                            ? [...new Array(9)]?.map((_, index) => (
                                <Placeholder key={index} />
                              ))
                            : myData?.map((obj: any) =>
                                obj.error != null ? (
                                  <div className='card-mn rounded'>
                                    <div className='card-body'>
                                      <h6 style={{ fontWeight: '600' }}>
                                        {obj.error}
                                      </h6>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <div className='buy-sec justify-content-between d-flex'>
                                      <div className='buy-t'>
                                        <h6>{obj.product_name}</h6>
                                        <span>Balance </span>
                                        <span style={{ marginLeft: '1rem' }}>
                                          Debits {obj.debits}
                                        </span>
                                        <span style={{ marginLeft: '1rem' }}>
                                          Credits {obj.credts}
                                        </span>
                                        <br />
                                        <span>
                                          <i
                                            className='fa fa-calendar'
                                            aria-hidden='true'
                                            style={{ marginRight: '8px' }}
                                          ></i>
                                          {converDate(obj.createdon)}
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                )
                              )}
                        </div>
                        <div></div>
                      </div>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyHistory;
